import { render, staticRenderFns } from "./SubHeadline.vue?vue&type=template&id=ebe09ec2"
import script from "./SubHeadline.vue?vue&type=script&lang=js"
export * from "./SubHeadline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports